export { SponsoredCard } from './SponsoredCard';
export type { SponsoredCardProps } from './types';
export {
  sponsoredCardVariants,
  sponsoredCardLogoBoxVariants,
  type SponsoredCardVariantProps,
} from './sponsored-card.variants';
